<template>
  <div class="main">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'layoutContainerMain'
}
</script>
<style lang="scss" scoped>
  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: $bg-color-main;
    padding: 30px 30px 26px 30px;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/container/main/index.vue